export { default } from './FitExtent';
